module.exports = __webpack_public_path__ + "img/avatar-7.7494f644.jpg";